import jsCookie from 'js-cookie';
import { debugMode, ieltsHost, ieltsNextWeb, ieltsWeb, isRemote } from '../env';
import { logError } from '../logger/arms-config';


const allowedHosts = [
  'v1.dauyan.net',
  'v1.dauyan.com',
  'ielts.dauyan.net',
  'ielts.dauyan.com',
  'share.dauyan.net',
  'share.dauyan.com',
  'app.dauyan.net',
  'app.dauyan.com',
  'test.dauyan.net',
  '172.16.80.171',
  '192.168.1.48',
  'www.donglyc.com',
  ieltsHost,
];
const whiteList = ['mobile-writing-upload-image'];

export function checkHost() {
  const v = jsCookie.get('VERSION');
  if (!v || v !== 'v0') {
    if (!debugMode && isRemote && window.location.host.includes('v1')) {
      if (whiteList.some((s) => window.location.pathname.includes(s))) {
        return;
      }
      window.location.href = ieltsNextWeb;
    }
  }
  if (!allowedHosts.includes(window.location.hostname)) {
    logError(`[非法域名]${window.location.href}`);
    setTimeout(() => {
      window.location.href = ieltsWeb;
    }, 100);
  }
}
